import React, { useState } from 'react';
import CompetitorMAPComplianceReport from '../components/Reports/CompetitorMAPComplianceReport';
import PricingBreakdownReport from '../components/Reports/PricingBreakdownReport';
import BuyboxWinRateReport from '../components/Reports/BuyboxWinRateReport';
import CompetitorProductsReport from '../components/Reports/CompetitorProductsReport';
import ImpactReport from '../components/Reports/ImpactReport';
import InventoryBuyboxMapReport from '../components/Reports/InventoryBuyboxMapReport';

function Reports() {
    const [selectedReport, setSelectedReport] = useState('');

    const handleReportChange = (e) => {
        setSelectedReport(e.target.value);
    };

    return (
        <div className="min-h-screen bg-gray-50 py-6 px-4 sm:px-6 lg:px-8">
            <div className="max-w-7xl mx-auto">
                <div className="bg-white shadow rounded-lg">
                    <div className="px-4 py-5 sm:p-6">
                        <h1 className="text-2xl font-semibold text-gray-900 mb-6">Reports</h1>

                        <div className="mb-6">
                            <label htmlFor="report-select" className="block text-sm font-medium text-gray-700 mb-2">
                                Select Report Type
                            </label>
                            <select
                                id="report-select"
                                value={selectedReport}
                                onChange={handleReportChange}
                                className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
                            >
                                <option value="">Select a Report</option>
                                <option value="competitor-map-compliance">Competitor MAP Compliance Report</option>
                                <option value="pricing-breakdown">Lowest Price Per Condition Breakdown</option>
                                <option value="buybox-win-rate">Buybox Win Rate Report</option>
                                <option value="competitor-products">Competitor Products Report</option>
                                <option value="impact-report">Impact Report</option>
                                <option value="inventory-buybox-map">Inventory & Buybox Map</option>
                            </select>
                        </div>

                        {selectedReport === 'competitor-map-compliance' && (
                            <CompetitorMAPComplianceReport />
                        )}

                        {selectedReport === 'pricing-breakdown' && (
                            <PricingBreakdownReport />
                        )}

                        {selectedReport === 'buybox-win-rate' && (
                            <BuyboxWinRateReport />
                        )}

                        {selectedReport === 'competitor-products' && (
                            <CompetitorProductsReport />
                        )}

                        {selectedReport === 'impact-report' && (
                            <ImpactReport />
                        )}

                        {selectedReport === 'inventory-buybox-map' && (
                            <InventoryBuyboxMapReport />
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Reports;
